import React from "react";
import { useStatuts } from "@/context/StatutsContext";

export function StatutBadge({ code, label, color, className = "", testid }) {
  const { statutMap } = useStatuts();
  const s = statutMap[code] || {};
  const c = color || s.color || "#94a3b8";
  const txt = label || s.label || code || "—";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide whitespace-nowrap ${className}`}
      style={{ backgroundColor: `${c}1a`, color: c, border: `1px solid ${c}40` }}
    >
      {txt}
    </span>
  );
}
